module.exports = __webpack_public_path__ + "img/3dForm1.15732ff8.svg";